export default {
  goods: {
    ru: ['товар', 'товара', 'товаров'],
    uk: ['товар', 'товари', 'товарів'],
    en: ['product', 'products', 'products'],
  },
}
